export function getGoodsGroup(goods, goodsId) {
  const goodsFound = goods.find(elem => elem.id === goodsId)
  return goodsFound ? goodsFound.group : -1
}
